export const PROMPT_LIBRARY_TAGS = {
  PROMPT_LIBRARY_TAG: "PromptLibrary",
};
